import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const indigo8BaseUrl = z
  .string()
  .trim()
  .transform((value, ctx) => {
    let url: URL;
    try {
      url = new URL(value);
    } catch {
      ctx.addIssue({
        code: "custom",
        message:
          "Indigo8 API URL must be a full URL, for example https://example.com",
      });
      return z.NEVER;
    }
    if (url.protocol !== "https:") {
      ctx.addIssue({
        code: "custom",
        message: "Indigo8 API URL must use https",
      });
      return z.NEVER;
    }
    return `${url.origin}/`;
  });

export const indigo8Settings = defineIntegrationSettings({
  fields: {
    baseUrl: indigo8BaseUrl,
    shopifyShopName: z.string().trim(),
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: { shopifyWebsiteUrl: z.string() },
});
